import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

const root = createRoot(document.getElementById("root")!);

// Simple immediate render without setTimeout - the React checks in components should handle timing
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
